import { TranslateLoader } from '@ngx-translate/core';
import { Observable, catchError, of, switchMap } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class CustomTranslateLoader implements TranslateLoader {
    constructor(
        public readonly http: HttpClient,
    ) {}

    getTranslation(lang: string): Observable<any> {
        return this.http.get('assets/i18n/' + lang + '.json');
    }

    // getTranslation(lang: string): Observable<any> {
    //     lang = lang.toLocaleUpperCase();
    //     return this.selectDictionaryApi(lang).pipe(
    //         switchMap((response: BaseResponseDictionaryDTO) => {
    //             if(response.data?.dictionary){
    //                 return of(response.data.dictionary);
    //             }
    //             return of({});
    //         },
    //     )).pipe(
    //         catchError((apiError: ApiError) => {
    //             console.dir(apiError);
    //             return of({});
    //         }
    //     ));
    // }

    // private selectDictionaryApi(lang: string): Observable<BaseResponseDictionaryDTO>{
    //     if(this._oauth2Service.isAuthenticated){
    //         return this._translationControllerService.dictionary((lang as any));
    //     }
    //     return this._translationControllerService.dictionaryMinimal((lang as any));
    // }
}
